<template>
  <v-carousel
    @change="$emit('update:workShopSlide', workShopSlide)"
    v-model="workShopSlide"
    style="height:100%"
    hide-delimiters
    :dark="$vuetify.theme.dark"
    :light="!$vuetify.theme.dark"
    height="100%"
  >
    <v-carousel-item class="first-page">
      <Welcome />
    </v-carousel-item>

    <v-carousel-item>
      <ProjectInformation />
    </v-carousel-item>

    <v-carousel-item>
      <IrwinStreetTrafficStudy />
    </v-carousel-item>

    <v-carousel-item>
      <ProposedAlignment />
    </v-carousel-item>

    <v-carousel-item>
      <ProposedPlanViews />
    </v-carousel-item>

    <v-carousel-item>
      <CrossSections />
    </v-carousel-item>

    <v-carousel-item>
      <PublicComment />
    </v-carousel-item>

    <v-carousel-item>
      <StayEngaged />
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import Welcome from "@/components/Welcome.vue";
import ProjectInformation from "@/components/ProjectInformation.vue";
import IrwinStreetTrafficStudy from "@/components/IrwinStreetTrafficStudy";
import ProposedAlignment from "@/components/ProposedAlignment.vue";
import ProposedPlanViews from "@/components/ProposedPlanViews.vue";
import CrossSections from "@/components/CrossSections.vue";
import StayEngaged from "@/components/StayEngaged.vue";
import PublicComment from "@/components/PublicComment.vue";

export default {
  name: "Workshop",
  components: {
    Welcome,
    ProjectInformation,
    IrwinStreetTrafficStudy,
    ProposedAlignment,
    ProposedPlanViews,
    CrossSections,
    PublicComment,
    StayEngaged
  },
  props: {
    workShopSlide: {
      type: Number,
      default: () => {
        return 0;
      }
    }
  },
  computed: {
    easelTop() {
      if (this.$vuetify.breakpoint.xs) {
        return "40%";
      }
      return "10%";
    },
    easelBottom() {
      if (this.$vuetify.breakpoint.xs) {
        return "100%";
      }
      return "33%";
    }
  }
};
</script>

<style>
.v-carousel__item {
  height: 100% !important;
  overflow-y: auto;
  background: url("../../public/static/Wall-with-Floor.png") !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: bottom !important;
}
.v-carousel__item p,
h1,
p {
  font-size: 1.3em;
  color: #000000 !important;
}

.wall-with-floor-background {
  background-color: rgba(0, 0, 0, 0) !important;
}
.popup {
  background-color: rgba(255, 255, 255, 1) !important;
}
.slide-content {
  padding: 5%;
  display: inline-block;
}
.theme--light {
  color: black !important;
}
.fill-height {
  height: 100% !important;
}
/* .v-card {
  background-color: rgba(255, 255, 255, 0.5) !important;
} */
.v-window__next,
.v-window__prev {
  position: fixed !important;
}
.slide-card {
  max-width: 100% !important;
  width: 90% !important;
  font-size: 1em !important;
  background-color: rgba(255, 255, 255, 0.5) !important;
}
.stayengaged-card {
  max-width: 50% !important;
  width: 90% !important;
  font-size: 1em !important;
  background-color: rgba(255, 255, 255, 0.5) !important;
}
@media only screen and (min-width: 350px) and (max-width: 1023px) {
  .slide-content {
    max-width: 100% !important;
    width: 100% !important;
    font-size: 1em !important;
  }
  /* .slide-card {
    max-width: 100% !important;
    width: 100% !important;
    font-size: 1em !important;
    background-color: rgba(255, 255, 255, 0.5) !important;
  } */
}
</style>
